const Aggression = require("../../entities/Aggression")
const {Age}  = require("../Constants");
const AggessionNames = require("../Names/AggressionNames");

class Plunder extends Aggression {
    constructor(age) {
        super(
            age,
            AggessionNames.Plunder,
            1,
            "Your rival loses a total of up to " + Plunder.GetResourceAmount(age) + " resources and/or food (your choice). You gain that many resources and food.",
            {
                //effect
            }
        )
    }

    static GetResourceAmount(age){
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 3;
            case Age.Age2:
                return 5;
            case Age.Age3:
                return 7;
        }
    }
}

module.exports = Plunder;